module.exports = __webpack_public_path__ + "media/images/icons/login_mobile-0f38563cd951c5c1575f57bdee1b69b8.svg";